<template>
  <v-container fluid class="pa-0">
    <v-row align="center" justify="space-between" class="mb-5">
      <v-col cols="12">
        <div class="page-title">Daily Attendance QR Codes</div>
        <div class="page-subtitle">
          Generate and display QR Codes for student daily time tracking.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" v-if="!expandTab1">
        <v-card flat rounded="xl" class="table-card pa-8 text-center">
          <div
            style="
              background-color: #dcfce7;
              width: 56px;
              height: 56px;
              margin: 0 auto;
            "
            class="rounded-xl d-flex align-center justify-center"
          >
            <v-icon size="28" color="#00A63E">mdi-qrcode</v-icon>
          </div>
          <div
            class="mt-3 font-weight-bold"
            style="font-size: 16px; color: #111827"
          >
            Ready to Start the Day?
          </div>
          <div
            class="text-grey mt-1"
            style="font-size: 13px; max-width: 420px; margin: 0 auto"
          >
            Generate unique QR Codes for today's morning and afternoon sessions.
            Students will scan these codes to log their attendance.
          </div>
          <div class="d-flex ga-4 justify-center">
            <v-btn
              color="#00A63E"
              variant="flat"
              class="text-white mt-5"
              prepend-icon="mdi-autorenew"
              rounded="lg"
              size="small"
              @click="(expandTab1 = !expandTab1), (qr_to_generate = 1)"
            >
              Morning Session QR Codes
            </v-btn>
            <v-btn
              color="warning"
              variant="flat"
              class="text-white mt-5"
              prepend-icon="mdi-autorenew"
              rounded="lg"
              size="small"
              @click="(expandTab1 = !expandTab1), (qr_to_generate = 2)"
            >
              Afternoon Session QR Codes
            </v-btn>
            <v-btn
              color="primary"
              variant="flat"
              class="text-white mt-5"
              prepend-icon="mdi-autorenew"
              rounded="lg"
              size="small"
              @click="(expandTab1 = !expandTab1), (qr_to_generate = 3)"
            >
              Overtime Session QR Codes
            </v-btn>
          </div>
        </v-card>
      </v-col>
      <v-col cols="12" v-if="expandTab1" class="">
        <v-card flat rounded="xl" class="table-card">
          <div class="d-flex align-center justify-space-between pa-4">
            <div>
              <div class="card-title">Today's QR Codes</div>
              <div style="font-size: 12px; color: #6b7280; margin-top: 2px">
                Scan to record attendance
              </div>
            </div>
            <v-btn
              variant="tonal"
              color="#00A63E"
              rounded="lg"
              size="small"
              prepend-icon="mdi-refresh"
              @click="(expandTab1 = false), (qr_to_generate = null)"
            >
              Reset
            </v-btn>
          </div>
          <v-divider />
          <div class="pa-4 d-flex justify-center ga-4">
            <v-card
              v-if="qr_to_generate == 1"
              flat
              rounded="xl"
              style="width: 50%; border: 1px solid #fed7aa"
            >
              <div
                style="background-color: #fff7ed; color: #9a3412"
                class="pa-3 d-flex align-center ga-2 rounded-t-xl"
              >
                <v-icon size="18" color="#ea580c">mdi-weather-sunny</v-icon>
                <span class="font-weight-bold" style="font-size: 13px"
                  >Morning Session</span
                >
              </div>
              <v-divider style="border-color: #fed7aa" />
              <div class="d-flex ga-3 pa-3">
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_am_in"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time In</div>
                </div>
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_am_out"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time Out</div>
                </div>
              </div>
            </v-card>
            <v-card
              v-if="qr_to_generate == 2"
              flat
              rounded="xl"
              style="width: 50%; border: 1px solid #bfdbfe"
            >
              <div
                style="background-color: #eff6ff; color: #1e40af"
                class="pa-3 d-flex align-center ga-2 rounded-t-xl"
              >
                <v-icon size="18" color="#3b82f6">mdi-weather-sunset</v-icon>
                <span class="font-weight-bold" style="font-size: 13px"
                  >Afternoon Session</span
                >
              </div>
              <v-divider style="border-color: #bfdbfe" />
              <div class="d-flex ga-3 pa-3">
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_pm_in"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time In</div>
                </div>
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_pm_out"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time Out</div>
                </div>
              </div>
            </v-card>
            <v-card
              v-if="qr_to_generate == 3"
              flat
              rounded="xl"
              style="width: 50%; border: 1px solid #bfdbfe"
            >
              <div
                style="background-color: #eff6ff; color: #1e40af"
                class="pa-3 d-flex align-center ga-2 rounded-t-xl"
              >
                <v-icon size="18" color="#3b82f6">mdi-weather-sunset</v-icon>
                <span class="font-weight-bold" style="font-size: 13px"
                  >Overtime Session</span
                >
              </div>
              <v-divider style="border-color: #bfdbfe" />
              <div class="d-flex ga-3 pa-3">
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_ot_in"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time In</div>
                </div>
                <div
                  class="qr-box border rounded-xl text-center pa-2"
                  style="width: 50%"
                >
                  <div class="pa-3 d-flex justify-center">
                    <qrcode-vue
                      :value="qr_ot_out"
                      :size="size"
                      level="H"
                      render-as="svg"
                    />
                  </div>
                  <div class="qr-label">Time Out</div>
                </div>
              </div>
            </v-card>
          </div>
        </v-card>
      </v-col>
    </v-row>

    <AddProfilingFieldDialog :data="fieldData" :action="action" />

    <v-dialog v-model="dialogConfirmDelete" max-width="500">
      <v-card>
        <v-card-title class="text-h6">Confirm Deletion</v-card-title>
        <v-card-text class="text-body-1">
          Are you sure you want to delete this item?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogConfirmDelete = false"
            >Cancel</v-btn
          >
          <v-btn color="error" class="white--text" @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <fade-away-message-component
      displayType="default"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :type="fadeAwayMessage.type"
    />
  </v-container>
</template>

<script>
import QrcodeVue from "qrcode.vue";

export default {
  components: {
    QrcodeVue,
  },

  // props: {
  //   reloadTable: {
  //     type: Boolean,
  //     required: true,
  //   },
  // },
  data: () => ({
    qr_to_generate: null,
    search: "",
    size: 200,
    headers: [
      { title: "Student", value: "name", align: "start" },
      { title: "Program", value: "pg_name", align: "start" },
      {
        title: "Assessments Taken",
        value: "assessment_taken",
        align: "center",
      },

      // {
      //   title: "Actions",
      //   value: "actions",
      //   align: "center",
      //   sortable: false,
      //   width: 200,
      // },
    ],
    data: [],

    programs_for: [],
    perPageChoices: [
      { text: "5", value: 5 },
      { text: "10", value: 10 },
      { text: "20", value: 20 },
      { text: "50", value: 50 },
      { text: "100", value: 100 },
      { text: "250", value: 250 },
      { text: "500", value: 500 },
    ],
    expandTab1: false,
    skill_assessment_list: [],
    added_fields: [],
    batchItem: null,
    totalCount: 0,
    group_data: null,
    deleteData: null,
    batchData: null,
    fieldData: null,
    studentList: [],
    itemData: null,
    viewData: null,
    loading: false,
    options: {},
    action: null,
    paginationData: {},
    formdata: [],
    creds: null,
    dialogConfirmDelete: false,
    fadeAwayMessage: {
      show: false,
      type: "success",
      header: "Successfully Deleted!",
      message: "",
      top: 10,
    },
  }),
  computed: {
    qr_am_in() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "am_in",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
    qr_am_out() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "am_out",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
    qr_pm_in() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "pm_in",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
    qr_pm_out() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "pm_out",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
    qr_ot_in() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "ot_in",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
    qr_ot_out() {
      const orgId = this.$store.state.user?.id;
      const payload = {
        type: "ot_out",
        org_id: orgId ?? null,
        date: new Date().toISOString().split("T")[0],
      };
      return JSON.stringify(payload);
    },
  },
  mounted() {},
  beforeUnmount() {},
  methods: {
    pagination(data) {
      this.paginationData = data;
    },
    initialize() {
      // this.loading = true;
      // if (this.tab == 1) {
      //   this.axiosCall("/skill-assessement/get-batch/", "GET").then((res) => {
      //     if (res) {
      //       console.log("Bacthers", res.data);
      //       this.batchData = res.data;
      //       this.loading = false;
      //     }
      //   });
      // } else if (this.tab == 2) {
      //   this.axiosCall("/student/get-batches", "GET").then((res) => {
      //     if (res) {
      //       console.log(res.data);
      //       this.batchData = res.data;
      //       this.loading = false;
      //     }
      //   });
      // } else if (this.tab == 3) {
      //   this.axiosCall("/student/get-batches-for-students", "GET").then(
      //     (res) => {
      //       if (res) {
      //         console.log(res.data);
      //         this.batchData = res.data;
      //         this.loading = false;
      //       }
      //     },
      //   );
      // }
    },

    changeTab(tab) {
      // this.activeTab = tab.abbr;
      // this.tab = tab.program_id;
      this.activeTab = tab.name;
      this.tab = tab.id;

      this.expandTab1 = false;

      this.expandTab2 = false;

      this.expandTab3 = false;

      this.initialize();
    },

    loadSAS() {
      this.axiosCall(
        "/skill-assessement/getSAByGroupId/" + this.q_bank_data.id,
        "GET",
      ).then((res) => {
        if (res) {
          this.skill_assessment_list = res.data;
        }
      });
    },

    loadAddedFields() {
      this.axiosCall(
        "/student/getAddedFieldsByBatch/" + this.batchItem.id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("FIELDs", res.data);
          this.added_fields = res.data;
        }
      });
    },

    loadStudents() {
      this.axiosCall(
        "/student/getAllStudentsByBatch/" + this.batchItem.id,
        "GET",
      ).then((res) => {
        if (res) {
          console.log("STUDNETDS", res.data);
          this.studentList = res.data;
        }
      });
    },

    getProgramsHandled() {
      this.axiosCall("/program/getProgramsHandled", "GET").then((res) => {
        if (res) {
          console.log("Prog", res.data);
          this.programs_for = res.data;
          // this.activeTab = res.data[0].abbr;
          // this.tabList = res.data;
          // this.tab = res.data[0].program_id;
          console.log(this.tabList);
          this.initialize();
        }
      });
    },
    addnew() {
      this.itemData = {
        id: null,
        skill_assessment_group_id: this.q_bank_data.id,
      };
      this.action = "Add";
    },

    addfield() {
      console.log("Bathid", this.batchItem);
      this.fieldData = {
        id: null,
        student_batch_id: this.batchItem.id,
      };
      this.action = "Add";
    },

    editField(item) {
      console.log("Bathid", this.batchItem);
      this.fieldData = item;
      this.action = "Update";
    },

    removeField(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this field?",
      );
      if (confirm) {
        this.axiosCall(
          "/student/remove_added_field/" + item.id,
          "DELETE",
          {},
        ).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadAddedFields();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },

    add_batch() {
      this.group_data = { id: null };
      this.action = "Add";
    },
    deleteItem(item) {
      let confirm = window.confirm(
        "Are you sure you want to delete this item and its contents?",
      );
      if (confirm) {
        this.axiosCall("/skill-assessement/removeSA", "POST", {
          skill_assessment_ids: JSON.stringify(item.skill_assessment_ids),
        }).then((res) => {
          if (res.data.status == 200) {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "success";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
            this.loadSAS();
          } else {
            this.fadeAwayMessage.show = true;
            this.fadeAwayMessage.type = "error";
            this.fadeAwayMessage.message = res.data.msg;
            this.fadeAwayMessage.header = "System Message";
          }
        });
      }
    },
    editItem(item) {
      this.itemData = item;
      this.action = "Update";
    },

    viewItem(item) {
      this.itemData = item;
      this.action = "View";
    },

    manageItem(item) {
      this.creds = item;
    },
    confirmDelete() {
      this.axiosCall("/request-type/" + this.deleteData.id, "DELETE").then(
        () => {
          this.fadeAwayMessage.show = true;
          this.itemData = null;
          this.initialize();
        },
      );
    },
  },
};
</script>

<style scoped>
.page-title {
  font-size: 30px;
  font-weight: 800;
  color: #111827;
  letter-spacing: -0.5px;
}
.page-subtitle {
  font-size: 14px;
  color: #6b7280;
  margin-top: 2px;
}
.table-card {
  border: 1px solid #d1d5db;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.06);
}
.card-title {
  font-size: 15px;
  font-weight: 700;
  color: #111827;
}
.qr-label {
  font-size: 11px;
  font-weight: 600;
  color: #6b7280;
  margin-top: 4px;
  margin-bottom: 4px;
}
.qr-box {
  border-color: #e5e7eb !important;
}
</style>
